export function formatCurrency(
  value: number | undefined,
  showFreeIfZero = false,
  currency = 'GBP',
) {
  if (value === undefined) {
    return '';
  }

  if (value === 0 && showFreeIfZero) {
    return 'FREE';
  }

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  }).format(value);
}
